import styled from "styled-components";

export const StyledServiceOrderWorkDeliveryDeliverWorkFormHelper = styled.div`
  border: 1px solid #ffe58f;
  border-radius: 5px;
  padding: 1.6rem 0.9rem;
  background-color: #fffbe6;
  color: #d48806;

  .helper-text {
    font-size: 1.4rem;

    &.bold {
      font-weight: 600;
    }
  }
`;
